/**
 * 这是一个zlgcloud API访问接口，通过fetch访问服务器数据，并返回Promise对象。
 * @copyright www.zlg.cn
 * @version  V0.1.1
 */
/* eslint-disable */
let url = {}
if ('undefined' === typeof weex) {
  if (window.location.host.indexOf('localhost') >= 0) {
    /* 开发环境的固定url */
    url.apiUrl = 'http://192.168.13.4:18081/v1'
    url.docUrl = 'http://192.168.13.4:18081'
  } else {
    /* 打包情况下，注释以上url，放开以下url，确保打包的项目能够在多个服务器下部署 */
    url.apiUrl = 'http://' + window.location.host + '/v1'
    url.docUrl = 'http://' + window.location.host
  }
}
/**
 * 获取 url.docUrl ，此用于App端获取头像功能
 */
ZlgCloudHelper.docUrl = function () {
  return url.docUrl
}
/**
 * 转化文件路径
 * @param {string} url - 静态文件路径
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获设备信息
 * catch函数捕获error信息：''
 */
ZlgCloudHelper.staticDocUrl = function (data) {
  let defaultParams = {
    url: ''
  }
  defaultParams = {
    ...data
  }
  // 以下静态资源文件访问路径，上线不用加url.docUrl，本地开发需要
  if (window.location.host.indexOf('localhost') >= 0) {
    return defaultParams.url ? url.docUrl + defaultParams.url : ''
  } else {
    return defaultParams.url ? defaultParams.url : ''
  }
}
/**
 * 设置网络请求头
 */
let header = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
}
/**
 * ZlgCloudHelper类---需要在公共的vue文件里面初始化vue，在created生命周期里面调用 ZlgCloudHelper(this)即可，否则会报错
 * @class ZlgCloudHelper
 * @constructor
 * @param {Object} value - 初始化vue的对象，适配中英文切换,这里需要在app.vue里面调用初始化
 */
let _this
let debounceErrorMessage

function debounce(func, delay) {
  var lastTimer
  return function () {
    let _this = this,
      args = arguments
    if (lastTimer) {
      clearTimeout(lastTimer)
    }
    lastTimer = setTimeout(function () {
      func.apply(_this, args)
    }, delay)
  }
}

function ZlgCloudHelper(value, urls) {
  _this = value
  if (typeof window !== 'undefined' && !window.debug) {
    debounceErrorMessage = debounce(_this.$message.error, 150)
  }
  if (urls) {
    if (window.location.host.indexOf('localhost') >= 0) {
      /* 开发环境的固定url */
      url.apiUrl = 'http://localhost:8081/api',
      url.docUrl ='https://lab.zlg.cn'
    } else {
      url = urls
    }
  }
}

const httpDefaultOpts = (url, method, data) => {
  let httpDefaultOpts = {
    // http默认配置
    method: method,
    baseURL: url.apiUrl,
    url: url,
    timeout: 20000,
    data: data,
    params: data,
    headers: header
  }
  if (method === 'get') {
    delete httpDefaultOpts.data
  } else {
    delete httpDefaultOpts.params
  }
  return httpDefaultOpts
}
/**
 * errorState --错误信息统一处理
 * @param {object} response - 请求回来的信数据
 * @param {string} errPosition - 在中英文切换的错误提示地址
 */
function errorState(response, errPosition) {
  if (typeof window !== 'undefined' && window.debug) {
    return
  }
  let errorMsg = ''
  let translateMessage = ''
  let commonTranslateMessage = ''
  let neterror = ''
  if (response) {
    if (errPosition && response.status) {
      translateMessage = _this.$t(`${errPosition}.${response.status}`)
      translateMessage =
        (translateMessage === `${errPosition}.${response.status}`) ? '' : translateMessage
    }
    if (!translateMessage && response.status) {
      commonTranslateMessage = _this.$t(`response.common.${response.status}`)
      commonTranslateMessage =
        (commonTranslateMessage === `response.common.${response.status}`) ? '' : commonTranslateMessage
    }
    errorMsg = translateMessage || commonTranslateMessage
  }
  if (typeof window !== 'undefined') {
    // errorMsg && _this.$message.error(errorMsg)
    errorMsg && debounceErrorMessage(errorMsg)
    if (response) {
      if (response.status === 401) {
        _this.$router.push('/login')
      }
    }
  }
  return errorMsg || _this.$t('response.common.offline')
}
/**
 * fetch函数
 * @param {string} url - 网址
 * @param {object} options - Option
 * @returns {Promise} - 可通过then和catch捕获fetch执行完成后的数据
 */
function Fetch(url, method, params, errPosition) {
  return new Promise((resolve, reject) => {
    /* eslint-disable */
    if ('undefined' !== typeof weex) {
      const bmAxios = weex.requireModule('bmAxios')
      var bmoptions = {}
      bmoptions.method = method.toUpperCase()
      bmoptions.url = encodeURI(url)
      bmoptions.header = header
      bmoptions.data = params
      bmoptions.timeout = 20000
      bmAxios.fetch(bmoptions, res => {
        const {
          status,
          errorMsg,
          data
        } = res
        if (status >= 200 && status < 300) {
          resolve(data)
        } else {
          let msg = errorMsg.replace(/\s/g, '')
          msg = msg.replace(/\(Code:-?[0-9]*\)/g, '')
          if (
            msg.includes('Unabletoresolvehost') ||
            msg.includes('Failedtoconnect')
          ) {
            msg = '似乎与互联网断开连接'
          }
          if (msg.includes('timeout')) {
            msg = '请求超时'
          }
          const transformMessage = errorState({
            status
          }, errPosition)
          reject({
            status,
            msg,
            transformMessage
          })
        }
      })
    } else {
      _this
        .$axios(httpDefaultOpts(url, method, params))
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            resolve(response.data)
          }
        })
        .catch(error => {
          if (error) {
            errorState(error.response, errPosition)
          }
          reject(error)
        })
    }
  })
}
// ***************************************label标签**********************************
// ***************************************用户**********************************
/**
 * 获取满足条件的用户,返回用户列表。列表信息由描述, 用户名, 用户角色, 手机号, 邮箱组成
 * @param {object} data - 查询条件，{ filter: '查询条件', skip: '跳过前面N条记录', limit: '最多N条记录' }
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获查询结果
 * catch函数捕获error信息：''
 */
ZlgCloudHelper.queryUsers = function (data) {
  let defaultParams = {
    filter: undefined,
    skip: 0,
    limit: undefined,
    aggregation: undefined
  }
  defaultParams = { ...data }
  return Fetch(url.apiUrl + '/users', 'get', defaultParams, 'user.getter')
}
/**
 * 注册用户
 * @param {object} data - 注册信息
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获{result: true, message: 'OK', data: {userinfo}}
 * catch函数捕获error信息:res: {resCode: 400, msg: 'xxxxx'}
 * regist({
 *  data: [{
 *    SupplierCode: ''
 *    SupplierName: '',
 *    SupplierEmail: '',
 *    PurchaserEmai: ''
 *  }]
 * }).then(() => {}).catch(() => {})
 */
ZlgCloudHelper.regist = function (data) {
  let defaultParams = {
    data: []
  }
  defaultParams = { ...data }
  return Fetch(url.apiUrl + '/users', 'post', defaultParams, 'user.poster')
}
/**
 * 获取用户信息
 * @param {Object)} username - 用户名
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获{result: true, message: 'XXXXXX'}
 * catch函数捕获error信息：res: {resCode: 400, msg: 'xxxxx'}
 */
ZlgCloudHelper.getUserinfor = function (data) {
  let defaultParams = {
    username: ''
  }
  defaultParams = { ...data }
  return Fetch(url.apiUrl + '/users/' + defaultParams.username, 'get', {}, 'user.getter')
}
/**
 * 更新用户信息
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获{result: true, message: 'XXXXXX'}
 * catch函数捕获error信息：''
 * @example
 * UpdateUserInfor({username: 'test',info: {
 *  SupplierName: '',
 *  language: '',
 *  desc: '',
 *  SupplierEmail: '',
 *  PurchaserEmai: ''
 * }}).then(() => {}).catch(() => {})
 */
ZlgCloudHelper.updateUserInfor = function (data) {
  let defaultParams = {
    username: '',
    info: {
      SupplierName: '',
      language: '',
      desc: '',
      SupplierEmail: '',
      PurchaserEmai: ''
    }
  }
  defaultParams = {
    ...data
  }
  return Fetch(
    url.apiUrl + '/users/' + defaultParams.username,
    'put',
    defaultParams.info,
    'user.putter'
  )
}
/**
 * 删除用户，登录之后方可删除，只可删除自己
 * @param {Object} data - 供应商代码数组
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获{result: true, message: 'XXXXXX'}
 * catch函数捕获error信息：''
 * @example
 * deleteUser(data: [供应商代码1, 供应商代码2]}).then(() => {}).catch(() => {})
 */
ZlgCloudHelper.deleteUser = function (data) {
  let defaultParams = {
    data: []
  }
  defaultParams = {
    ...data
  }
  return Fetch(
    url.apiUrl + '/users/del',
    'post', defaultParams,
    'user.deleter'
  )
}
/**
 * 用户登录
 * @param {Object} data - 登录数据
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获{result: true, message: 'XXXXXX'}
 * catch函数捕获error信息
 * @example
 * Login({
 *  username: 'test',
 *  password: '12345678',
 * }).then(() => {}).catch(() => {})
 */
ZlgCloudHelper.login = function (data) {
  let defaultParams = {
    username: '',
    password: ''
  }
  defaultParams = {
    ...data
  }
  return Fetch(url.apiUrl + '/users/login', 'post', defaultParams, 'auth.login')
}
/**
 * 用户退出
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获{result: true, message: 'OK'}
 * catch函数捕获error信息
 */
ZlgCloudHelper.logout = function () {
  return Fetch(url.apiUrl + '/users/logout', 'post', {})
}
/**
 * 修改密码
 * @param {Object} data - 修改密码数据
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获{result: true, message: 'XXXXXX'}
 * catch函数捕获error信息
 * @example
 * ChangePassword({
 *  oldpassword: '12345678',
 *  newpassword: '12312312',
 * }).then(() => {}).catch(() => {})
 */
ZlgCloudHelper.changePassword = function (data) {
  let defaultParams = {
    oldpassword: '',
    newpassword: ''
  }
  defaultParams = {
    ...data
  }
  return Fetch(
    url.apiUrl + '/users/update_password',
    'post',
    defaultParams,
    'auth.changePassword'
  )
}
/**
 * 重置密码
 * @param {Object} data - 供应商代码数组
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获{result: true, message: 'XXXXXX'}
 * catch函数捕获error信息
 * @example
 * ResetPassword({
 *  data: [供应商代码1, 供应商代码2]
 * }).then(() => {}).catch(() => {})
 */
ZlgCloudHelper.resetPassword = function (data) {
  let defaultParams = {
    data: []
  }
  defaultParams = {
    ...data
  }
  return Fetch(url.apiUrl + '/users/reset_password', 'post', defaultParams)
}
/**
 * 通知新密码
 * @param {Object} data - 供应商代码数组
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获{result: true, message: 'XXXXXX'}
 * catch函数捕获error信息
 * @example
 * ResetPassword({
 *  data: [供应商代码1, 供应商代码2]]]
 * }).then(() => {}).catch(() => {})
 */
ZlgCloudHelper.notifyNewPassword = function (data) {
  let defaultParams = {
    data: []
  }
  defaultParams = {
    ...data
  }
  return Fetch(url.apiUrl + '/users/notify_new_password', 'post', defaultParams)
}
// ***************************************订单管理**********************************
/**
 * 获取满足条件的订单,返回订单列表。
 * @param {object} data - 查询条件
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获查询结果
 * catch函数捕获error信息：''
 */
ZlgCloudHelper.queryOrders = function (data) {
  let defaultParams = {
    SupplierCode: '',
    PONo: '',
    ItemCode: '',
    IsFinished: ''
  }
  defaultParams = { ...data }
  return Fetch(url.apiUrl + '/orders', 'get', defaultParams, 'orders.getter')
}

// ***************************************标签管理**********************************
/**
 * 获取满足条件的标签,返回标签列表。
 * @param {object} data - 查询条件
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获查询结果
 * catch函数捕获error信息：''
 */
ZlgCloudHelper.queryLabels = function (data) {
  let defaultParams = {
    filter: undefined,
    skip: 0,
    limit: undefined,
    aggregation: undefined
  }
  defaultParams = { ...data }
  return Fetch(url.apiUrl + '/projects', 'get', defaultParams, 'user.getter')
}
/**
 * 创建标签, 返回创建标签信息。
 * @param {object} data - 标签信息数组
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获查询结果
 * catch函数捕获error信息：''
 * @example
 * addLabels({
 *  data: [{
 *    SupplierCode: "string",
 *    PONo: "string",
 *    ItemID: "string",
 *    ItemCode: "string",
 *    ItemName: "string",
 *    ItmeModel: "string",
 *    MinPackQty: 0,
 *    D_C: "string",
 *    QtyOfBox: 0
 *  }]
 * }).then().catch()
 *
 */
ZlgCloudHelper.addLabels = function (data) {
  let defaultParams = {
    data: []
  }
  defaultParams = {
    ...data
  }
  return Fetch(url.apiUrl + '/projects', 'post', defaultParams, 'response.common')
}
/**
 * 更新标签, 返回创建标签信息。
 * @param {object} data - 标签id数组
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获查询结果
 * catch函数捕获error信息：''
 * @example
 * updateLabels({
 *  data: ['labelid01', 'labelid02']
 * }).then().catch()
 *
 */
ZlgCloudHelper.updateLabels = function (data) {
  let defaultParams = {
    data: [],
    info: {printed: true}
  }
  defaultParams = {
    ...data
  }
  return Fetch(url.apiUrl + '/projects', 'put', defaultParams, 'response.common')
}
/**
 * 删除标签。
 * @param {object} data - 标签id数组
 * @returns {Promise} - 可通过then和catch捕获执行完成后的数据，then函数捕获查询结果
 * catch函数捕获error信息：''
 * @example
 * deleteLabels({
  *  data: ['labelid01', 'labelid02']
  * }).then().catch()
  *
  */
 ZlgCloudHelper.deleteLabels = function (data) {
   let defaultParams = {
     data: []
   }
   defaultParams = {
     ...data
   }
   return Fetch(url.apiUrl + '/projects/del', 'post', defaultParams, 'response.common')
 }
ZlgCloudHelper.url = url
export default ZlgCloudHelper



// WEBPACK FOOTER //
// ./src/native/zlgcloudhelper.js